import * as contractNames from './contractsData';

import onboardingCoursierImgStep1 from '../styles/img/onboarding/onboarding_coursier_step1.svg'
import onboardingCoursierImgStep2 from '../styles/img/onboarding/onboarding_coursier_step2.svg'
import onboardingCoursierImgStep3 from '../styles/img/onboarding/onboarding_coursier_step3.svg'

export const onboardingData = {
  // Devenir Coursier
  302: {
    name: contractNames.DEVENIR_COURSIER,
    totalSteps: 3,
    step_1: {
      title: "Créer une micro-entreprise",
      htmlTitle:
        "Créer une <span class='onboardingModal-content-title_highlightedText'><span>micro-entreprise</span><div/></span>",
      content:
        "En tant que coursier à vélo, vous n'êtes pas salarié. Vous devez donc créer une micro-entreprise pour pouvoir facturer et être payé.",
      img: onboardingCoursierImgStep1
    },
    step_2: {
      title: "Obtenir un extrait Kbis",
      htmlTitle:
        "Obtenir un extrait <span class='onboardingModal-content-title_highlightedText'><span>Kbis</span><div/></span>",
      content:
        "Un extrait KBIS est en quelque sorte la carte d’identité d’une entreprise, il permet de confirmer que vous avez bien votre propre entreprise. Ce document est obligatoire pour devenir coursier.",
      img: onboardingCoursierImgStep2
    },
    step_3: {
      title:
        "Démarrer votre activité",
      htmlTitle:
        "Démarrer votre <span class='onboardingModal-content-title_highlightedText'><span>activité</span><div/></span>",
      content:
        "Une fois que avez obtenu votre extrait Kbis, vous pouvez vous inscrire sur la plateforme de votre choix (ex: Uber Eats, Deliveroo, etc).",
      img: onboardingCoursierImgStep3
    }
  }
};



// WEBPACK FOOTER //
// ./src/constants/onboardingData.js